import AutoTypeIcon from '@components/icons/CargoTypeIcons/AutoTypeIcon';
import { RouteWidgetBaseParameters } from '@pages/AdditionalServices/tabs/DeliveryForm/types';
import { calculateCargoForTruck } from '@pages/Basket/components/ServicesList/components/OrderList/components/OrderListItem/helpers';
import { TruckParameters } from '@services/requests/orderService/types';
import clsx from 'clsx';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { getPalletDescriptions } from '../helpers';

interface FullResultTruckProps {
  truckParameter: TruckParameters;
  mainLanguage: string;
  BaseData: RouteWidgetBaseParameters;
  truckIndex: number;
}

function FullResultTruck({
  truckParameter,
  mainLanguage,
  BaseData,
  truckIndex,
}: FullResultTruckProps) {
  const { t } = useTranslation('Common');

  const truckCargoDescription = calculateCargoForTruck(
    BaseData.trucks,
    truckParameter,
    mainLanguage
  );

  const palletDescriptions = getPalletDescriptions(
    truckParameter.palletsLoaded,
    BaseData.units,
    mainLanguage,
    t('Common:kg')
  );

  return (
    <div className="selection-result-item">
      <div
        className={clsx('selection-result-item__cargo', {
          'has-pallets': truckParameter.palletsLoaded.length > 0,
        })}
      >
        <div className="selection-result-item__icon">
          <AutoTypeIcon />
        </div>
        <span className="selection-result-item__title">{truckCargoDescription}</span>
      </div>

      {palletDescriptions.length > 0 && (
        <div className="selection-result-item__pallets">
          <span className="selection-result-item__pallets-title">
            {t('Common:CargoSelection.SelectionDialog.PalletsTitle')}
          </span>
          {palletDescriptions.map((desc, i) => (
            <span key={`truck-${truckIndex}-pallet-${i}`} className="selection-result-item__pallet">
              {desc}
            </span>
          ))}
        </div>
      )}
    </div>
  );
}

export { FullResultTruck };
